(function ( $ ){

	var defaults = {
	}

	$.fn.setHeightToViewport = function(options){

		var options = options || {};

		return this.each(function(){

			var setHeight = function(element){

//				if (element.css("height", "auto").outerHeight(true) < Math.ceil($(window).height())){
//
//					//element.outerHeight(Math.ceil($(window).height()));
//
//					var margin = element.outerHeight(true) - element.innerHeight();
//					element.css("min-height", Math.ceil($(window).height() - margin));
//
//				}

				var margin = element.outerHeight(true) - element.innerHeight();
				element.css("min-height", Math.ceil($(window).height() - margin));

			};

			var settings = $.extend({}, defaults, options);

			var kontext = $(this);

			setHeight(kontext);

			$(window).on("resize", function(event){
				setHeight(kontext);
			}, 250);

		});

	}

}( jQuery ));